/**
 * AdminPeopleRpcClient — AtomRpc integration for the admin people dedupe
 * `search` endpoint (match by email OR phone). Requires admin authentication
 * via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminPeopleRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminPeopleRpcClient extends AtomRpc.Tag<AdminPeopleRpcClient>()(
  "AdminPeopleRpcClient",
  {
    group: AdminPeopleRpcs,
    protocol: makeRpcClientLayer(AdminPeopleRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
